<script setup lang="ts">
import {
  AlertDialogRoot,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
} from 'reka-ui';
import { confirmState, resolveConfirm } from '@/shared/feedback/confirm';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

function onOpenChange(open: boolean) {
  if (!open && confirmState.open) {
    resolveConfirm(false);
  }
}
</script>

<template>
  <AlertDialogRoot :open="confirmState.open" @update:open="onOpenChange">
    <AlertDialogPortal>
      <AlertDialogOverlay
        class="fixed inset-0 z-[100] bg-black/40 backdrop-blur-[2px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
      />
      <AlertDialogContent
        :class="
          cn(
            'fixed left-1/2 top-1/2 z-[100] grid w-[calc(100vw-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 gap-4 overflow-hidden border border-border bg-background p-6 shadow-notion-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:rounded-lg'
          )
        "
      >
        <AlertDialogTitle class="text-lg font-semibold leading-none tracking-tight">
          {{ confirmState.title }}
        </AlertDialogTitle>
        <AlertDialogDescription
          v-if="confirmState.description"
          class="max-h-48 overflow-y-auto break-all text-sm text-muted-foreground whitespace-pre-wrap"
        >
          {{ confirmState.description }}
        </AlertDialogDescription>
        <div class="flex shrink-0 flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-2">
          <Button variant="outline" @click="resolveConfirm(false)">
            {{ confirmState.cancelText }}
          </Button>
          <Button
            :variant="confirmState.variant === 'destructive' ? 'destructive' : 'default'"
            @click="resolveConfirm(true)"
          >
            {{ confirmState.confirmText }}
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialogPortal>
  </AlertDialogRoot>
</template>
